import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { documentToReactComponents, } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { Tablet } from '@hellodarwin/core/lib/components/common/Media';
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import CTAsList from '../../../common/CTAsList';
import GatsbyLink from '../../../common/Link/ContentfulLink';
import { CTAsContainer } from '../styles';
const defaultTextOptions = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return children;
        },
        [INLINES.HYPERLINK]: (node, children) => {
            const { uri: url } = node.data;
            return (_jsx("div", { style: { marginTop: 16 }, children: _jsx(GatsbyLink, { url: url, children: children }) }));
        },
    },
};
const IntroDescription = ({ style, withBorder, bodyLong, ctAs, textAlign, }) => {
    const theme = useTheme();
    const borderPos = useMemo(() => (style === null || style === void 0 ? void 0 : style.paddingLeft)
        ? `calc(100% - (${style.paddingLeft}px - ${theme.spacing.md}px))`
        : `calc(100% + ${theme.spacing.md}px)`, [style, theme.spacing.md]);
    return (_jsxs(Div, { flex: "column", gap: theme.spacing.lg, style: Object.assign(Object.assign({}, style), { textAlign, position: 'relative' }), children: [!!withBorder && (_jsx(Tablet, { direction: "up", children: _jsx("div", { style: {
                        position: 'absolute',
                        borderBottom: `1px solid ${theme.colors.grey_1}`,
                        width: withBorder === 'left' ? '100vw' : 600,
                        right: withBorder === 'left' ? borderPos : undefined,
                        left: withBorder === 'right' ? borderPos : undefined,
                        top: `calc(${theme.fontsLineHeights.body1} / 2)`,
                    } }) })), !!bodyLong && (_jsx(Typography, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 24,
                    alignItems: textAlign === 'left'
                        ? 'flex-start'
                        : textAlign === 'right'
                            ? 'flex-end'
                            : 'center',
                }, children: documentToReactComponents(bodyLong, defaultTextOptions) })), !!(ctAs === null || ctAs === void 0 ? void 0 : ctAs.length) && (_jsx(CTAsContainer, { children: _jsx(CTAsList, { CTAs: ctAs.map((ct) => ct.fields) }) }))] }));
};
export default IntroDescription;
